var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphicBottomRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 200,
    viewBox: "0 0 130 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 120.353C130 83.5899 79.0013 30 42.2138 30C5.4264 30 27.7647 62.8804 27.7647 99.6432C27.7647 116.816 -3.04428 149.845 0.245988 165.054C4.51158 184.771 26.4609 200 46.0643 200C82.8517 200 130 157.116 130 120.353Z",
    fill: "#D6EFF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90 18.3673C90 27.497 101.074 34.2857 110.204 34.2857C119.334 34.2857 120 25.3541 120 16.2245C120 7.09488 116.885 0 107.755 0C98.6255 0 90 9.23774 90 18.3673Z",
    fill: "#D6EFF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicBottomRight);
export default __webpack_public_path__ + "static/media/Graphic-BottomRight.fb2abfb308c5f3415097ff32c5904d2f.svg";
export { ForwardRef as ReactComponent };